<template>
  <div class="home">
    <error-message :error-object="errorObject" />
    <v-container fluid>
      <v-row v-if="isShowCategory('top')">
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-select
            v-model="disaster"
            :items="disasters"
            label="災害名称"
            item-text="disaster_name"
            item-value="disaster_no"
            clearable
            return-object
            outlined
            @change="update"
            :placeholder="config.PLACEHOLDER_SELECT"
          >
            <template v-slot:selection="data">
              {{ disasterName(data.item) }}
            </template>
            <template v-slot:item="data">
              {{ disasterName(data.item) }}
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="6" md="8" lg="8">
          <v-card flat class="pa-4">災害名称を選択してください</v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('disaster')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>災害名称管理</v-toolbar-title>
              <v-btn icon @click="disasterShow = !disasterShow">
                <v-icon>{{
                  disasterShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>災害名称の操作を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="disasterShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF0205', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/disaster">
                        <v-card-title
                          >災害名称一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4">
                        発災時及び訓練開始時に、災害対策本部にて災害情報を登録します<br />
                        また、登録された災害情報を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF0201')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/disaster">
                        <v-card-title>災害名称一覧（参照）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >登録された災害情報を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('oil')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>OIL管理</v-toolbar-title>
              <v-btn icon @click="oilShow = !oilShow">
                <v-icon>{{
                  oilShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>OILレベルの更新を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="oilShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF2001', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/oil">
                        <v-card-title>OIL一覧（登録・編集・削除）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >災害のOILレベルを市町村ごとに設定します <br />
                        市町村の中で一番高いOILレベルを設定します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF2001')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/oil">
                        <v-card-title>OIL一覧（参照）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >災害のOILレベルを確認します</v-card
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('map')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>地図表示</v-toolbar-title>
              <v-btn icon @click="mapShow = !mapShow">
                <v-icon>{{
                  mapShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>各種情報の地図表示を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="mapShow">
                <v-container fluid>
                  <v-row v-if="isShowMapMenu()">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        dark
                        @click="openMap"
                        :disabled="!disaster || disaster.disaster_no == ''"
                        :class="
                          !disaster || disaster.disaster_no == ''
                            ? 'mapInvalidButton'
                            : 'mapValidButton'
                        "
                      >
                        <v-card-title
                          :class="
                            !disaster || disaster.disaster_no == ''
                              ? 'mapInvalidButtonText'
                              : 'mapValidButtonText'
                          "
                        >
                          地図表示</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >各種情報を地図上に表示します<br />
                        画面上部の災害名称を選択してからお使いください</v-card
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('evacuationOrder')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>避難指示管理</v-toolbar-title>
              <v-btn icon @click="evacuationOrderShow = !evacuationOrderShow">
                <v-icon>{{
                  evacuationOrderShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>住民へ避難指示の広報を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="evacuationOrderShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF0302', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/evacuation-order">
                        <v-card-title
                          >住民向け広報一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF0301')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/evacuation-order">
                        <v-card-title>住民向け広報一覧（参照）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('lalert')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>Lアラート管理</v-toolbar-title>
              <v-btn icon @click="lalertShow = !lalertShow">
                <v-icon>{{
                  lalertShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>Lアラートの配信を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="lalertShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF2101', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/lalert">
                        <v-card-title
                          >Lアラート一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF2101')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/lalert">
                        <v-card-title>Lアラート一覧（参照）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('managerOrder')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>防災関係者指示管理</v-toolbar-title>
              <v-btn icon @click="managerOrderShow = !managerOrderShow">
                <v-icon>{{
                  managerOrderShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>防災関係者への情報通知を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="managerOrderShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF1801', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/manager-order">
                        <v-card-title
                          >防災関係者向け広報一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF1801')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/manager-order">
                        <v-card-title
                          >防災関係者向け広報一覧（参照）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('evacueeStatus')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>避難者状況管理</v-toolbar-title>
              <v-btn icon @click="evacueeStatusShow = !evacueeStatusShow">
                <v-icon>{{
                  evacueeStatusShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>避難所や避難者の状況把握を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="evacueeStatusShow">
                <v-container fluid>
                  <v-row v-if="isShowMenu('SF1301')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/shelter-status">
                        <v-card-title>避難所状況一覧</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >避難所毎の状況を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenu('SF1303')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/evacuee-status">
                        <v-card-title>避難者検索一覧</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >避難者の状況を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('chronology')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>クロノロジー情報管理</v-toolbar-title>
              <v-btn icon @click="chronologyShow = !chronologyShow">
                <v-icon>{{
                  chronologyShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>クロノロジーの操作を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="chronologyShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF0406', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/chronology">
                        <v-card-title
                          >クロノロジー情報一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >災害に関する様々な情報の記録を登録・編集・削除します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF0402')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/chronology">
                        <v-card-title
                          >クロノロジー情報一覧（参照）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >災害に関する様々な情報の記録を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('qrcode')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>ＱＲコード管理</v-toolbar-title>
              <v-btn icon @click="qrcodeShow = !qrcodeShow">
                <v-icon>{{
                  qrcodeShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>ＱＲコードの操作を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="qrcodeShow">
                <v-container fluid>
                  <v-row v-if="isShowMenu('SF0601')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/facility-qr-code">
                        <v-card-title>要配慮者施設ＱＲコード発行</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >病院や福祉施設に入居している患者や要配慮者の情報を登録し、避難時に使う仮ＱＲコードを発行します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenu('SF0604')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/school-qr-code">
                        <v-card-title>学校ＱＲコード発行</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >学校の生徒情報を登録し、避難時に使う仮ＱＲコードを発行します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenu('SF0607')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/temporary-qr-code">
                        <v-card-title>仮ＱＲコード発行</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >発災時にスマートフォンを所有していない住民や一時滞在者に配布する仮ＱＲコードを発行します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenu('SF0610')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/bus-qr-code">
                        <v-card-title>バスＱＲコード印刷</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >バス一覧やバスＱＲコードを印刷します</v-card
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('facilityStatus')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>要配慮者施設管理</v-toolbar-title>
              <v-btn icon @click="facilityStatusShow = !facilityStatusShow">
                <v-icon>{{
                  facilityStatusShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>避難元の要配慮者施設の状況把握を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="facilityStatusShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF1506', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/facility-status/vulner-people"
                      >
                        <v-card-title>施設状況一覧（編集）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF1505')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/facility-status/vulner-people"
                      >
                        <v-card-title>施設状況一覧（参照）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('facilityStatusNuc')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>原子力災害関係施設管理</v-toolbar-title>
              <v-btn
                icon
                @click="facilityStatusNucShow = !facilityStatusNucShow"
              >
                <v-icon>{{
                  facilityStatusNucShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>原子力防災関係施設の状況把握を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="facilityStatusNucShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF1406', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/facility-status/nuclear-disaster"
                      >
                        <v-card-title>施設状況一覧（編集）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF1405')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/facility-status/nuclear-disaster"
                      >
                        <v-card-title>施設状況一覧（参照）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('stableIodine')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>安定ヨウ素剤配布状況管理</v-toolbar-title>
              <v-btn icon @click="stableIodineShow = !stableIodineShow">
                <v-icon>{{
                  stableIodineShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>安定ヨウ素剤の配布状況の把握を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="stableIodineShow">
                <v-container fluid>
                  <v-row v-if="isShowMenu('SF1001')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/stable-iodine">
                        <v-card-title>安定ヨウ素剤配布状況一覧</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenu('SF1002')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/stable-iodine-personal">
                        <v-card-title
                          >安定ヨウ素剤事前配布状況個人検索</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('user')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>ユーザ管理</v-toolbar-title>
              <v-btn icon @click="userShow = !userShow">
                <v-icon>{{
                  userShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>操作権の管理を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="userShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF1207', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/user">
                        <v-card-title
                          >ユーザ情報（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        本システムを利用するユーザー情報の登録・編集・削除を行います</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF1201')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/user">
                        <v-card-title>ユーザ情報一覧（参照）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        本システムを利用するユーザー情報を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenuCrud('SF1208', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/user-authorization-operation"
                      >
                        <v-card-title
                          >操作権限付与一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        本システムを利用するユーザーの操作権限設定を登録・編集します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF1204')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/user-authorization-operation"
                      >
                        <v-card-title>操作権限付与一覧（参照）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        本システムを利用するユーザーの操作権限設定を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('master')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>マスタ管理</v-toolbar-title>
              <v-btn icon @click="masterShow = !masterShow">
                <v-icon>{{
                  masterShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>マスタ情報の管理を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="masterShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF1401')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/disaster-prevention-fa-mst"
                      >
                        <v-card-title
                          >原子力災害関係施設マスタ一覧（参照）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        原子力防災施設（避難所、一時集合場所、避難退域時検査場所）に関する様々な情報を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF1402', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/disaster-prevention-fa-mst"
                      >
                        <v-card-title
                          >原子力災害関係施設マスタ一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        原子力防災施設（避難所、一時集合場所、避難退域時検査場所）に関する様々な情報の登録・編集・削除を行います</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenuCrud('SF1501')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/vulner-people-fa-mst">
                        <v-card-title
                          >要配慮者施設マスタ一覧（参照）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        要配慮者施設（病院、学校、福祉施設）に関する様々な情報を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF1502', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/vulner-people-fa-mst">
                        <v-card-title
                          >要配慮者施設マスタ一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        要配慮者施設（病院、学校、福祉施設）に関する様々な情報の登録・編集・削除を行います</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenuCrud('SF3001')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/disaster-fixedphrase-mst"
                      >
                        <v-card-title
                          >災害配信定型文マスタ一覧（参照）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        住民向け、防災関係者向けの災害配信メールの定型文を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF3002', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/disaster-fixedphrase-mst"
                      >
                        <v-card-title
                          >災害配信定型文マスタ一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        住民向け、防災関係者向けの災害配信メールの定型文の登録・編集・削除を行います</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenuCrud('SF3101')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/info-guide-mst">
                        <v-card-title
                          >情報ガイドマスタ一覧（参照）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        住民向けに提供する防災関連ファイル（防災のしおり、避難地図&nbsp;等）の情報を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF3102', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/info-guide-mst">
                        <v-card-title
                          >情報ガイドマスタ一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        住民向けに提供する防災関連ファイル（防災のしおり、避難地図&nbsp;等）の登録・編集・削除を行います</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenuCrud('SF4001')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/autonomy-mst">
                        <v-card-title
                          >自治会マスタ一覧（参照）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        自治会に関する様々な情報を確認します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF4002', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/autonomy-mst"
                      >
                        <v-card-title
                          >自治会マスタ一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >システム管理者向け機能です<br />
                        自治会に関する様々な情報の登録・編集・削除を行います</v-card
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('car')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>車両管理</v-toolbar-title>
              <v-btn icon @click="carShow = !carShow">
                <v-icon>{{
                  carShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>避難車両の管理を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="carShow">
                <v-container fluid>
                  <v-row v-if="isShowMenuCrud('SF1701', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/car">
                        <v-card-title
                          >管理車両一覧（登録・編集・削除）</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="isShowMenuCrud('SF1701')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/car">
                        <v-card-title>管理車両一覧（参照）</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"></v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="isShowCategory('otherSystems')">
        <v-col>
          <v-card>
            <v-app-bar>
              <v-toolbar-title>他システム連携</v-toolbar-title>
              <v-btn icon @click="otherSystemsShow = !otherSystemsShow">
                <v-icon>{{
                  otherSystemsShow ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <div>他システムとの連携を行います</div>
            </v-app-bar>
            <v-expand-transition>
              <div v-show="otherSystemsShow">
                <v-container fluid>
                  <v-row v-if="isShowMenu('SF1901')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark @click.stop="showDpnd">
                        <v-card-title>避難車両配車システム表示</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >避難車両配車システムを表示します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenuCrud('SF1902', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card
                        color="primary"
                        dark
                        to="/equipment-deploy-register"
                      >
                        <v-card-title>防災資機材の配備状況取込</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >原子力防災資機材管理システムからダウンロードし変換したCSVファイルを取り込みます</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenuCrud('SF1903', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/stable-iodine-register">
                        <v-card-title
                          >安定ヨウ素剤の事前配布状況取込</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >安定ヨウ素剤配布管理システムからダウンロードした2種類のCSVファイルを取り込みます</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenu('SF1904')">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark to="/inspection-result-list">
                        <v-card-title>避難退域時検査場所状況表示</v-card-title>
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >避難退域時検査場所での車両検査結果の状況を表示します</v-card
                      >
                    </v-col>
                  </v-row>
                  <v-row v-if="isShowMenuCrud('SF4101', false)">
                    <v-col cols="12" sm="6" md="4" lg="4">
                      <v-card color="primary" dark @click.stop="showAdjustmentSystem">
                        <v-card-title
                          >調整システム表示</v-card-title
                        >
                        <v-card-text></v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" md="8" lg="8">
                      <v-card flat class="pa-4"
                        >調整システムを表示します</v-card
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import disasterUtils from "@/mixins/disaster-utils";
import handleError from "@/mixins/handle-error";
import ScreenAuthority from "@/plugins/screen-authority";
import Disaster from "@/plugins/disaster";
import config from "@/js/const";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { DisasterTranslator } from "@/js/translators/disasterTranslator";
import { ScreenId } from "@/js/value-objects/screen-id";
import { DisasterClass } from "@/js/value-objects/disaster-class";
import { ScreenCrud } from "@/js/value-objects/screen-crud";

Vue.use(Disaster);
Vue.use(ScreenAuthority);

const disasterInfoRepository = RepositoryFactory.get("disasterInfo");
const systemInfoRepository = RepositoryFactory.get("systemInfo");
const mapRepository = RepositoryFactory.get("map");
const dpndAuthInfoRepository = RepositoryFactory.get("dpndAuthInfo");

// メニュー分類とメニューの画面IDの対応一覧
const MENU_LIST = {
  top: [ScreenId.SF0001, ScreenId.SF0101, ScreenId.SF0102],
  disaster: [ScreenId.SF0201, ScreenId.SF0205],
  evacuationOrder: [ScreenId.SF0301, ScreenId.SF0302],
  evacueeStatus: [ScreenId.SF1301, ScreenId.SF1303],
  chronology: [ScreenId.SF0402, ScreenId.SF0406],
  qrcode: [ScreenId.SF0601, ScreenId.SF0604, ScreenId.SF0607, ScreenId.SF0610],
  stableIodine: [ScreenId.SF1001, ScreenId.SF1002],
  facilityStatus: [ScreenId.SF1505, ScreenId.SF1506],
  facilityStatusNuc: [ScreenId.SF1405, ScreenId.SF1406],
  user: [ScreenId.SF1201, ScreenId.SF1207, ScreenId.SF1204, ScreenId.SF1208],
  master: [
    ScreenId.SF1401,
    ScreenId.SF1402,
    ScreenId.SF1501,
    ScreenId.SF1502,
    ScreenId.SF3001,
    ScreenId.SF3002,
    ScreenId.SF3101,
    ScreenId.SF3102,
    ScreenId.SF4001,
    ScreenId.SF4002
  ],
  car: [ScreenId.SF1701],
  managerOrder: [ScreenId.SF1801],
  lalert: [ScreenId.SF2101],
  oil: [ScreenId.SF2001],
  map: [ScreenId.SF9001],
  otherSystems: [ScreenId.SF1901, ScreenId.SF1903, ScreenId.SF1904, ScreenId.SF4101]
};

export default {
  mixins: [disasterUtils, handleError],

  components: {
    ErrorMessage: () => import("@/components/ErrorMessage")
  },

  data: () => ({
    overlay: false,
    disasterShow: false,
    evacuationOrderShow: false,
    evacueeStatusShow: false,
    chronologyShow: false,
    qrcodeShow: false,
    stableIodineShow: false,
    facilityStatusShow: false,
    facilityStatusNucShow: false,
    userShow: false,
    masterShow: false,
    carShow: false,
    managerOrderShow: false,
    lalertShow: false,
    oilShow: false,
    mapShow: false,
    otherSystemsShow: false,
    disasters: [],
    config: config,
    disaster: {}
  }),

  watch: {
    $route: "initialize"
  },

  mounted() {
    this.pageTitle("メニュー");
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;
      // 最新の災害名称取得
      this.disasters = await disasterInfoRepository
        .unfinished(ScreenId.SF0102)
        .then(response => {
          return DisasterTranslator.sortByDisasterNo(
            response.data.results,
            true
          );
        })
        .catch(error => {
          this.handleError(error, ScreenId.SF0102, "error");
        });
      // 災害名称設定
      if (this.$disaster) {
        this.disaster = this.$disaster;
      } else {
        const latestDisaster = this.getLatestDisaster(this.disasters);
        this.disaster = latestDisaster;
        this.$disaster = this.defaultDisaster(latestDisaster);
      }
      this.overlay = false;
    },

    /**
     * 災害名称変更処理
     */
    update(disaster) {
      this.$disaster = this.defaultDisaster(disaster);
    },

    /**
     * 災害名称取得
     */
    disasterName(item) {
      return DisasterClass.getDisasterName(
        item.disaster_cls,
        item.disaster_name
      );
    },

    /**
     * メニューの表示制御
     * 参照画面の場合、readFlagにtrue
     * 登録・編集・削除画面の場合、readFlagにfalseを設定する
     */
    isShowMenuCrud(screenId, readFlag = true) {
      return this.$screenAuthority.some(auth => {
        if (auth.screen_id === screenId) {
          const screenCrud = ScreenCrud.factory(auth.screen_crud);
          const checkCrud = readFlag
            ? screenCrud.isRead()
            : screenCrud.isOperation();
          return checkCrud;
        }
        return false;
      });
    },

    /**
     * メニューの表示制御
     */
    isShowMenu(screenId) {
      return this.$screenAuthority.some(auth => {
        if (auth.screen_id === screenId) {
          if (auth.screen_crud) {
            return true;
          }
        }
        return false;
      });
    },

    /**
     * メニュー分類表示制御
     * 表示するメニューが1つ以上あるメニュー分類を表示する
     */
    isShowCategory(categoryId) {
      // メニュー分類に対応する画面IDのリストを取得
      const targetScreenIdList = MENU_LIST[categoryId];
      const targetScreenAuthority = this.$screenAuthority.filter(
        auth => auth.screen_crud && targetScreenIdList.includes(auth.screen_id)
      );
      if (!targetScreenAuthority.length) {
        return false;
      }
      // 各メニュー分類毎にメニューの表示条件を設定
      switch (categoryId) {
        case "top":
          // ログイン・トップ・メニュー
          return targetScreenAuthority.some(
            auth => auth.screen_id === ScreenId.SF0102
          );
        case "disaster":
          // 災害名称管理
          return targetScreenAuthority.some(auth => {
            // SF0201 参照権があれば表示
            if (auth.screen_id === ScreenId.SF0201) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isRead();
            }
            // SF0205 更新権があれば表示
            if (auth.screen_id === ScreenId.SF0205) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isOperation();
            }
            // 上記以外 参照権・更新権どちらでも表示
            return true;
          });
        case "evacuationOrder":
          // 避難指示管理
          return targetScreenAuthority.some(auth => {
            // SF0301 参照権があれば表示
            if (auth.screen_id === ScreenId.SF0301) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isRead();
            }
            // SF0302 更新権があれば表示
            if (auth.screen_id === ScreenId.SF0302) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isOperation();
            }
            // 上記以外 参照権・更新権どちらでも表示
            return true;
          });
        case "evacueeStatus":
          // 避難者状況管理
          return true;
        case "chronology":
          // クロノロジー情報管理
          return targetScreenAuthority.some(auth => {
            // SF0402 参照権があれば表示
            if (auth.screen_id === ScreenId.SF0402) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isRead();
            }
            // SF0406 更新権があれば表示
            if (auth.screen_id === ScreenId.SF0406) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isOperation();
            }
            // 上記以外 参照権・更新権どちらでも表示
            return true;
          });
        case "qrcode":
          // ＱＲコード管理
          return true;
        case "stableIodine":
          // 安定ヨウ素剤配布状況管理
          return true;
        case "user":
          // ユーザ管理
          return targetScreenAuthority.some(auth => {
            // SF1201, SF1204 参照権があれば表示
            if ([ScreenId.SF1201, ScreenId.SF1204].includes(auth.screen_id)) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isRead();
            }
            // SF1207, SF1208 更新権があれば表示
            if ([ScreenId.SF1207, ScreenId.SF1208].includes(auth.screen_id)) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isOperation();
            }
            // 上記以外 参照権・更新権どちらでも表示
            return true;
          });
        case "facilityStatusNuc":
          // 原子力災害関係施設管理
          return targetScreenAuthority.some(auth => {
            //SF1405 参照権があれば表示
            if (auth.screen_id === ScreenId.SF1405) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isRead();
            }
            // SF1402, SF1406 更新権があれば表示
            if (auth.screen_id === ScreenId.SF1406) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isOperation();
            }
            // 上記以外 参照権・更新権どちらでも表示
            return true;
          });
        case "facilityStatus":
          // 要配慮者施設管理
          return targetScreenAuthority.some(auth => {
            // SF1505 参照権があれば表示
            if (auth.screen_id === ScreenId.SF1505) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isRead();
            }
            // SF1506 更新権があれば表示
            if (auth.screen_id === ScreenId.SF1506) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isOperation();
            }
            // 上記以外 参照権・更新権どちらでも表示
            return true;
          });
        case "master":
          // マスタ管理
          return true;
        case "car":
          // 車両管理
          return true;
        case "managerOrder":
          // 防災関係者指示管理
          return true;
        case "lalert":
          // L-アラート
          return true;
        case "oil":
          // OIL管理
          return true;
        case "map":
          // 地図表示
          return true;
        case "otherSystems":
          // 他システム連携
          return targetScreenAuthority.some(auth => {
            // SF1903 更新権があれば表示
            if (auth.screen_id === ScreenId.SF1903) {
              const screenCrud = ScreenCrud.factory(auth.screen_crud);
              return screenCrud.isOperation();
            }
            // 上記以外 参照権・更新権どちらでも表示
            return true;
          });
        default:
          break;
      }
      return false;
    },


    /**
     * 地図表示ボタンを非アクティブにするか
     */
    isShowMapMenu() {
      // 参照／更新権限のどちらかを持っていることを確認している
      return (
        this.isShowMenuCrud("SF9001") || this.isShowMenuCrud("SF9001", false)
      );
    },

    /**
     * 地図表示を開く処理
     * 地図は特殊な手順で画面を開くため
     */
    async openMap() {
      this.overlay = true;
      // 地図システムのAPIに必要なパラメータを取得
      // value:userId
      // value2:accessToken
      // value3:zoomLevel
      // value4:latitude
      // value5:longitude
      await systemInfoRepository
        .list(ScreenId.SF0102, "MAP_AUTH_INFO")
        .then(mapAccessRes => {
          // 地図システム：認証処理
          // 成功なら別タブで画面を開く
          // 500エラーなら本画面で表示する
          var mapScreenAuth = this.$screenAuthority.filter(
            auth => auth.screen_id == "SF9001"
          );
          // 一致データは1つしか見つからないので、配列から取り出している
          var mapAccessInfo = mapAccessRes.data.results.filter(res => {
            return res.key == mapScreenAuth[0].auth_level;
          })[0];
          mapRepository
            .auth({
              userId: mapAccessInfo.value,
              municipalityId: "",
              zoomLevel: mapAccessInfo.value3,
              latitude: mapAccessInfo.value4,
              longitude: mapAccessInfo.value5,
              disasterId: this.disaster.disaster_no,
              accessToken: mapAccessInfo.value2
            })
            .then(async res => {
              this.overlay = false;
              // 稀にオーバーレイが画面に残るので、
              // オーバーレイを消す処理開始から0.1秒遅らせている。
              await new Promise(function(resolve) {
                setTimeout(resolve, 100);
              });
              window.open(
                mapRepository.getAccessURI(`?success_id=${res.data.success.id}`)
              );
            })
            .catch(e => {
              this.handleCreateError(e);
            });
        })
        .catch(e => {
          this.handleError(e, ScreenId.SF0102, "error");
          return;
        });

      this.overlay = false;
    },

    async showDpnd() {
      // DPND認証パラメータ取得
      this.overlay = true;
      var urlInfo = await dpndAuthInfoRepository
        .get(ScreenId.SF1901)
        .catch(error => {
          this.handleError(error, ScreenId.SF1901, "error");
        });
      this.overlay = false;

      window.setTimeout(function() {
        window.open(urlInfo.data.url);
      }, 1000);
    },
    
    /**
     * 調整システムを別ウィンドウで起動
     */
    async showAdjustmentSystem() {
      window.open('/index_adjustment.html', '_blank');
    }

  }
};
</script>

<style scoped>
.mapValidButton {
  background-color: #1976d2;
  border-color: #1976d2;
}

.mapInvalidButton {
  background-color: #e0e0e0;
  border-color: #e0e0e0;
}

.mapValidButtonText {
  color: #ffffff;
}

.mapInvalidButtonText {
  color: #a6a6a6;
}
</style>
